import { render, staticRenderFns } from "./CierreCaja.vue?vue&type=template&id=225ea573&scoped=true"
import script from "./CierreCaja.vue?vue&type=script&lang=js"
export * from "./CierreCaja.vue?vue&type=script&lang=js"
import style0 from "./CierreCaja.vue?vue&type=style&index=0&id=225ea573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ea573",
  null
  
)

export default component.exports